import { render, staticRenderFns } from "./Marks.vue?vue&type=template&id=2ac2acb4&"
import script from "./Marks.vue?vue&type=script&lang=js&"
export * from "./Marks.vue?vue&type=script&lang=js&"
import style0 from "./Marks.vue?vue&type=style&index=0&id=2ac2acb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports